// local.js

const config = {
  environment: 'TEST',
  preem_api: 'http://localhost:8080',
  assets: '/assets'
};

export default config;
